import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import HeaderComponent from "./components/header/HeaderComponent";
import HomeComponent from "./components/home/HomeComponent";
import EventComponent from "./components/event/EventComponent";
import FooterComponent from "./components/footer/FooterComponent";
import { AuthProvider } from "./context/AuthContext";
import EventInformationComponent from "./components/eventInformationComponent/EventInformationComponent";
import ElearningHub from "./components/elearningHub/ElearningHub";
import CourseInternalInformationComponent from "./components/courseInternalInformationComponent/CourseInternalInformationComponent";
import RegisterExternal from "./components/registerExternal/RegisterExternal";
import { QueryClient, QueryClientProvider, useQuery } from '@tanstack/react-query'
import CoursePoepComponent from "./components/coursePoep/CoursePoep";
import CourseRouterComponent from "./components/courses/CourseRouterComponent";
import { CourseContentProvider } from "./context/CourseContentContext";
import { ContextProyectProvider } from "./context/ContextProyect";

const queryClient = new QueryClient()

export const imagesDirectory = "../public";

function App() {

  const source = sessionStorage.getItem("source");

  return (
    <>
      <AuthProvider>
        <ContextProyectProvider>
          <QueryClientProvider client={queryClient}>
            <Router>
              <Routes>
                <Route path="/inicio"
                  element={
                    <Navigate to="/e-learning-hub" />
                  }
                />
                <Route
                  path="/eventos"
                  element={
                    <HeaderWrapper>
                      <EventComponent />
                    </HeaderWrapper>
                  }
                />
                <Route
                  path="/eventos/:id_event"
                  element={
                    <HeaderWrapper>
                      <EventInformationComponent />
                    </HeaderWrapper>
                  }
                />
                <Route
                  path="/e-learning-hub"
                  element={
                    <HeaderWrapper>
                      <ElearningHub />
                    </HeaderWrapper>
                  }
                />
                <Route
                  path="/cursos/:nameCourse"
                  element={
                    <CourseRouterComponent />
                  }
                />
                <Route
                  path="/cursos/:nameCourse/:nameTopic/:idtask"
                  element={
                    <HeaderWrapper>
                      <CourseContentProvider>
                        <CourseInternalInformationComponent />
                      </CourseContentProvider>
                    </HeaderWrapper>
                  }
                />
                <Route path="/register-external-poep" element={<RegisterExternal />} />
                {source == 'POEP' ?
                  <Route
                    path="*"
                    element={
                      <HeaderWrapper>
                        <Navigate to="/e-learning-hub" replace />
                      </HeaderWrapper>
                    }
                  />
                  : <Route
                    path="*"
                    element={
                      <HeaderWrapper>
                        <Navigate to="/inicio" replace />
                      </HeaderWrapper>
                    }
                  />}

              </Routes>
            </Router>
          </QueryClientProvider>
        </ContextProyectProvider>
      </AuthProvider >
    </>
  );
}

export default App;

function HeaderWrapper({ children }) {
  return (
    <>
      <HeaderComponent />
      {children}
      <FooterComponent />
    </>
  );
}
